import Paper from '@mui/material/Paper'
import { styled, alpha } from '@mui/material/styles'
import PropTypes from 'prop-types'

const LiquidGlassPaper = styled(Paper, {
  shouldForwardProp: prop => !['border', 'opacity', 'blur'].includes(prop),
})(({ theme, border = true, opacity = 0.25, blur = 12 }) => {
  const border1 = theme.palette.background.default
  const border2 = theme.palette.background.paper
  const surfaceColor = alpha(theme.palette.background.paper, opacity)

  return {
    position: 'relative',
    borderRadius: theme.shape.borderRadius * 2,
    backgroundColor: surfaceColor,
    backdropFilter: `blur(${blur}px)`,
    WebkitBackdropFilter: `blur(${blur}px)`,
    border: 'none',
    zIndex: 1,

    ...(border && {
      '&::before': {
        content: '""',
        position: 'absolute',
        zIndex: -1,
        inset: 0,
        borderRadius: 'inherit',
        padding: '1px',
        background: `linear-gradient(to bottom right, ${border1}, ${border2})`,
        mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        maskComposite: 'exclude',
        WebkitMaskComposite: 'xor',
      },
    }),
  }
})

LiquidGlassPaper.propTypes = {
  children: PropTypes.node,
  border: PropTypes.bool,
  /** 0–1 background opacity. Higher = more readable over map tiles (default: 0.25) */
  opacity: PropTypes.number,
  /** Backdrop blur in px (default: 12) */
  blur: PropTypes.number,
}

export default LiquidGlassPaper
